import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {Grid} from "@mui/material";
import {UserAgentUtils} from "../../utils/useragent";
import NewSidebar from "../../components/NewSidebar";

/**
 * @returns {ConnectedComponent<RequireAuthentication, DistributiveOmit<GetProps<RequireAuthentication>, keyof Shared<{token: *} & DispatchProp<AnyAction>, GetProps<RequireAuthentication>>> & {}>}
 */
export default function (ComposedComponent) {
    class RequireAuthentication extends Component {

        UNSAFE_componentWillMount() {
            if (!this.props.token) {
                this.props.history.push("/logout");
            }
        }

        UNSAFE_componentWillUpdate(nextProps) {
            if (!nextProps.token) {
                nextProps.history.push("/logout");
            }
        }

        PropTypes = {
            router: PropTypes.object,
        };

        render() {
            if (!UserAgentUtils.isMobile()) {
                return (
                    <Grid
                        container
                        flexWrap={"nowrap"}
                    >
                        <ComposedComponent {...this.props} />
                    </Grid>
                )
            } else {
                return (
                    <div>
                        <ComposedComponent {...this.props} />
                    </div>
                )
            }

        }
    }

    const mapStateToProps = (state) => {
        return {
            authorizations: state.authentication.authorizations,
            token: state.authentication.token,
        };
    };

    return connect(mapStateToProps)(RequireAuthentication);
}
